import { TransferType } from '../..';

export function _mapTransferTypeToPayerAndPaymentType(transferType: string): [string, string] {
    let payer = 'UNKNOWN_PAYER';
    let paymentType = 'UNKNOWN_PAYMENT_TYPE';
    if (transferType === TransferType.BUYER_TO_CREDITOR) {
        payer = 'BUYER';
        paymentType = 'EARLY_PAY_REMITTANCE';
    }
    if (transferType === TransferType.BUYER_TO_FBO) {
        payer = 'BUYER';
        paymentType = 'INVOICE_TERM';
    }
    if (transferType === TransferType.EARLY_PAYMENT) {
        payer = 'LSQ';
        paymentType = 'EARLY_PAYMENT';
    }
    if (transferType === TransferType.FBO_TO_CREDITOR) {
        payer = 'DEPOSIT_ACCOUNT';
        paymentType = 'INVOICE_TERM';
    }
    if (transferType === TransferType.ON_TERM_PAYMENT) {
        payer = 'LSQ';
        paymentType = 'PAY_LATER_PAYMENT';
    }
    if (transferType === TransferType.FUNDER_TO_FBO) {
        payer = 'LSQ';
        paymentType = 'PAY_LATER_PAYMENT';
    }
    if (transferType === TransferType.BUYER_TO_FUNDER) {
        payer = 'BUYER';
        paymentType = '----';
    }
    return [payer, paymentType];
}
